import { useLang } from "../i18n/LanguageProvider";

// Elegant institutional partner "logo" tiles. Each brand is rendered as a
// bespoke typographic mark on a gold-outlined tile — designed to convey
// prestige without unlicensed use of third-party trademarks.

const partners = [
  { id: "julius-baer", label: "JULIUS BÄR", sub: "Custodian", weight: 500, tracking: "0.12em", size: "1.05rem", style: "serif" },
  { id: "ubs", label: "UBS", sub: "Custodian", weight: 700, tracking: "0.32em", size: "1.35rem", style: "sans" },
  { id: "pictet", label: "Pictet & Cie", sub: "Custodian", weight: 400, tracking: "0.04em", size: "1.15rem", style: "serif", italic: true },
  { id: "lombard-odier", label: "LOMBARD ODIER", sub: "Custodian", weight: 500, tracking: "0.18em", size: "0.95rem", style: "serif" },
  { id: "hsbc", label: "HSBC", sub: "Custodian", weight: 700, tracking: "0.30em", size: "1.4rem", style: "sans" },
  { id: "rothschild", label: "Rothschild & Co", sub: "Advisory", weight: 400, tracking: "0.03em", size: "1.1rem", style: "serif" },
  { id: "blackrock", label: "BLACKROCK", sub: "Manager", weight: 700, tracking: "0.20em", size: "1.05rem", style: "sans" },
  { id: "kkr", label: "KKR", sub: "Private Equity", weight: 800, tracking: "0.28em", size: "1.5rem", style: "sans" },
  { id: "blackstone", label: "BLACKSTONE", sub: "Alternatives", weight: 600, tracking: "0.18em", size: "1rem", style: "serif" },
  { id: "carlyle", label: "The Carlyle Group", sub: "Alternatives", weight: 500, tracking: "0.04em", size: "1rem", style: "serif" },
  { id: "brookfield", label: "BROOKFIELD", sub: "Real Assets", weight: 700, tracking: "0.22em", size: "1.05rem", style: "sans" },
  { id: "partners-group", label: "PARTNERS GROUP", sub: "Alternatives", weight: 500, tracking: "0.20em", size: "0.95rem", style: "sans" },
];

const styleFor = (p) => ({
  fontFamily: p.style === "serif" ? '"Playfair Display", ui-serif, Georgia, serif' : '"Outfit", ui-sans-serif, sans-serif',
  fontWeight: p.weight,
  letterSpacing: p.tracking,
  fontSize: p.size,
  fontStyle: p.italic ? "italic" : "normal",
});

export const PartnerLogos = () => {
  const { t } = useLang();
  return (
    <section className="relative py-24 lg:py-32 border-y border-[var(--bw-border)] bg-surface overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-12 grid grid-cols-1 lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-7">
          <div className="eyebrow mb-4">{t("home.networkEyebrow")}</div>
          <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl text-white leading-tight max-w-2xl">
            {t("home.networkTitle")}
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-muted text-sm leading-relaxed">
            {t("home.networkLede")}
          </p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-[var(--bw-border)]">
          {partners.map((p) => (
            <div
              key={p.id}
              className="relative bg-[var(--bw-bg)] hover:bg-surface-2 transition-colors duration-500 h-32 flex flex-col items-center justify-center px-6 group"
              data-testid={`partner-${p.id}`}
            >
              <div
                className="text-white/85 group-hover:text-gold transition-colors duration-500 text-center"
                style={styleFor(p)}
              >
                {p.label}
              </div>
              <div className="text-[9px] tracking-[0.32em] uppercase text-muted mt-3 opacity-70 group-hover:opacity-100 transition-opacity">
                {p.sub}
              </div>
              <span className="absolute top-0 left-0 w-6 h-px bg-[var(--bw-gold)] opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="absolute bottom-0 right-0 w-6 h-px bg-[var(--bw-gold)] opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>

        <div className="mt-8 text-[10px] tracking-[0.32em] uppercase text-muted text-center">
          Custodians · Institutional Managers · Advisory Counterparties
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
